import server_api from "data/server_apis/server_api";

export const getStatistics = (machine=null) => {
    const resp = server_api.get(`/sales/statistics?machine=${machine ?? ""}`);
    return resp;
  };

  export const getProductsInMachine = (machine=null,page=1) => {
    const resp = server_api.get(`/commodity/product-arrangement/product_analytics?machine=${machine ?? ""}&page=${page}`);
    return resp;
  };  
  
  export const getProductPriceInMachine = (machine=null) => {
    const resp = server_api.get(`/commodity/product-arrangement/product_total_product_price?machine=${machine ?? ""}&page_size=36`);
    return resp;
  };

  export const getProductsSoldInMachine = (machine=null,page=1,date_iso_after="",date_iso_before="") => {
    const resp = server_api.get(`/sales/invoice/analytics?machine=${machine ?? ""}&page=${page}&date_iso_after=${date_iso_after}&date_iso_before=${date_iso_before}`);
    return resp;
  };  
  
  export const getProductsSoldPriceInMachine = (machine=null,date_iso_after="",date_iso_before="",page_size=20) => {
    const resp = server_api.get(`/sales/invoice/product_total_product_price?machine=${machine ?? ""}&date_iso_after=${date_iso_after}&date_iso_before=${date_iso_before}&page_size=${page_size}`);
    return resp;
  };